
import { Options, Vue } from "vue-class-component";

@Options({})
export default class PracticalUse extends Vue {
  // msg!: string;
}
